import { Box, BoxProps } from '@mui/material';

const VectorLayers = (props: BoxProps): JSX.Element => {
  return (
    <Box {...props}>
      <svg
        width="79"
        height="72"
        viewBox="0 0 79 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_7470_122607)">
          <path
            d="M29.7584 30.3324L28.8132 29.1677L29.7584 30.3324ZM74.6939 14.9331C75.1784 14.2611 75.0263 13.3236 74.3543 12.8391L63.4033 4.94451C62.7313 4.46005 61.7938 4.61209 61.3094 5.2841C60.8249 5.95611 60.9769 6.89361 61.6489 7.37806L71.3832 14.3955L64.3657 24.1298C63.8813 24.8018 64.0333 25.7393 64.7053 26.2237C65.3773 26.7082 66.3148 26.5561 66.7993 25.8841L74.6939 14.9331ZM5.60137 66.8658C6.9832 67.4493 6.98316 67.4494 6.98316 67.4494C6.98322 67.4493 6.98326 67.4492 6.98337 67.4489C6.98359 67.4484 6.98398 67.4475 6.98453 67.4462C6.98563 67.4436 6.98739 67.4394 6.98981 67.4337C6.99464 67.4224 7.00208 67.4049 7.01211 67.3815C7.03217 67.3346 7.06256 67.2638 7.10304 67.1704C7.18398 66.9837 7.30522 66.7065 7.46467 66.3488C7.78362 65.6334 8.2553 64.5963 8.86317 63.3168C10.0794 60.7569 11.8382 57.2324 14.007 53.3763C18.3723 45.615 24.2973 36.6964 30.7037 31.4971L28.8132 29.1677C21.9388 34.7468 15.7853 44.0949 11.3922 51.9056C9.18188 55.8356 7.39152 59.4235 6.15344 62.0294C5.53414 63.3329 5.05236 64.3922 4.72463 65.1273C4.56074 65.4949 4.43534 65.7816 4.35048 65.9774C4.30805 66.0753 4.27575 66.1504 4.25384 66.2017C4.24288 66.2273 4.23452 66.2469 4.2288 66.2604C4.22593 66.2671 4.22373 66.2723 4.22218 66.276C4.22141 66.2778 4.2208 66.2792 4.22036 66.2803C4.22014 66.2808 4.21993 66.2813 4.21982 66.2815C4.21966 66.2819 4.21953 66.2822 5.60137 66.8658ZM30.7037 31.4971C37.5263 25.96 48.2035 21.9566 57.3369 19.3306C61.8745 18.026 65.9765 17.0761 68.9438 16.4526C70.4268 16.141 71.6246 15.9113 72.4497 15.7598C72.8622 15.684 73.1814 15.6278 73.3964 15.5908C73.5038 15.5723 73.5852 15.5585 73.6392 15.5495C73.6661 15.545 73.6863 15.5417 73.6993 15.5395C73.7059 15.5384 73.7106 15.5377 73.7136 15.5372C73.7151 15.5369 73.7162 15.5368 73.7168 15.5367C73.7171 15.5366 73.7172 15.5366 73.7174 15.5366C73.7174 15.5366 73.7173 15.5366 73.4771 14.0559C73.237 12.5753 73.2367 12.5753 73.2362 12.5754C73.2359 12.5754 73.2354 12.5755 73.2348 12.5756C73.2336 12.5758 73.2319 12.5761 73.2299 12.5764C73.2257 12.5771 73.2197 12.5781 73.212 12.5794C73.1965 12.5819 73.174 12.5856 73.1446 12.5906C73.0858 12.6004 72.9994 12.615 72.8868 12.6344C72.6616 12.6732 72.3316 12.7313 71.9079 12.8091C71.0604 12.9647 69.8374 13.1994 68.3269 13.5168C65.3071 14.1513 61.1318 15.118 56.5079 16.4474C47.3184 19.0896 36.1362 23.2245 28.8132 29.1677L30.7037 31.4971Z"
            fill="#1F1F1F"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_7470_122607"
            x="0.219727"
            y="0.662109"
            width="78.7573"
            height="70.7871"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_7470_122607"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_7470_122607"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </Box>
  );
};

export default VectorLayers;
